import React from 'react'
import EodShapedQueue from '../shared/EodShapedQueue'

const ErpQueue = () => (
    <EodShapedQueue
        queue="erp"
        title="ERP Sync"
        depthText="outlet day(s) still queued or syncing — normal during the evening EOD window."
        failedText="outlet day(s) never reached the ERP. Finance will not see those sales until the job is retried."
    />
)

export default ErpQueue
